import { Modal as MuiModal, Typography, styled } from '@mui/material';
import { Button } from './Button';

type modalSizeType = 'small' | 'medium' | 'large';

function Modal(props: {
    children: React.ReactElement | Array<React.ReactElement | boolean>;
    isOpen: boolean;
    close: () => void;
    onConfirm: () => void;
    confirmButtonLabel?: string;
    title?: string;
    size?: modalSizeType;
}) {
    const confirmLabel = computeConfirmButtonLabel();
    const { onConfirm, isOpen } = props;

    const ModalComponent = modalComponentMapping[props.size || 'large'];

    return (
        <StyledModal open={isOpen} onClose={props.close}>
            <ModalComponent>
                {!!props.title && (
                    <ModalHeader>
                        <Title variant="h2">{props.title}</Title>
                    </ModalHeader>
                )}
                <ModalBody>{props.children}</ModalBody>

                <ModalFooter>
                    <ButtonContainer>
                        <Button variant="contained" onClick={onConfirm}>
                            {confirmLabel}
                        </Button>
                    </ButtonContainer>
                </ModalFooter>
            </ModalComponent>
        </StyledModal>
    );

    function computeConfirmButtonLabel() {
        let confirmButtonLabel = props.confirmButtonLabel || 'Confirmer';

        return confirmButtonLabel;
    }
}

const ModalHeader = styled('div')(({ theme }) => ({
    position: 'sticky',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: 'white',
    top: 0,
    zIndex: 10,
}));

const ModalFooter = styled('div')(({ theme }) => ({
    position: 'sticky',
    bottom: 0,
    zIndex: 10,

    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}));

const modalDefaultProperties = {
    borderRadius: '2px',
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'space-between',
    paddingLeft: '16px',
    paddingRight: '16px',
    overflow: 'auto',

    backgroundColor: 'white',
};
const ButtonContainer = styled('div')(({ theme }) => ({
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
}));

const SmallModalContent = styled('div')({
    ...modalDefaultProperties,
    minWidth: '30%',
    minHeight: '30%',
    maxHeight: '30%',
    maxWidth: '30%',
});

const MediumModalContent = styled('div')({
    ...modalDefaultProperties,
    minWidth: '60%',
    minHeight: '60%',
    maxHeight: '60%',
    maxWidth: '60%',
});

const LargeModalContent = styled('div')({
    ...modalDefaultProperties,
    minWidth: '80%',
    minHeight: '80%',
    maxHeight: '80%',
    maxWidth: '80%',
});

const modalComponentMapping: Record<modalSizeType, any> = {
    small: SmallModalContent,
    medium: MediumModalContent,
    large: LargeModalContent,
};

const ModalBody = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));
const Title = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(1) }));

const StyledModal = styled(MuiModal)({ zIndex: 999 });

export { Modal };
